<template>
  <div class="grow-wrap" :data-replicated-value="textAreaValue">
    <slot />
  </div>
</template>
<script setup lang="ts">
defineProps<{ textAreaValue: string }>();
</script>
<style>
/* https://css-tricks.com/the-cleanest-trick-for-autogrowing-textareas/ */
.grow-wrap {
  /* easy way to plop the elements on top of each other and have them both sized based on the tallest one's height */
  display: grid;
}
.grow-wrap::after {
  /* Note the weird space! Needed to preventy jumpy behavior */
  content: attr(data-replicated-value) ' ';

  /* This is how textarea text behaves */
  white-space: pre-wrap;

  /* Hidden from view, clicks, and screen readers */
  visibility: hidden;
}
.grow-wrap > textarea {
  /* You could leave this, but after a user resizes, then it ruins the auto sizing */
  resize: none;

  overflow: auto;
}
.grow-wrap > textarea,
.grow-wrap::after {
  padding: 0;

  /* Place on top of each other */
  grid-area: 1 / 1 / 2 / 2;
}
</style>
